<script>
/**
 * Extendable component for use in View/Page components.
 * Manages API hydration and transactional state management.
 */
export default {
  data() {
    return {
      apiError: null,
      apiLoading: false,
      apiLoaded: false,
    };
  },
  methods: {
    /**
     * Perform initial hydration with a collection of Promises and
     * optional Promise callback methods.
     *
     * @param {Promise[]} promises
     * @returns {Promise} Chainable result of promise collection
     */
    initialHydration(promises) {
      if (!promises || promises.length === 0) {
        return Promise.resolve();
      }

      this.apiLoading = true;
      return Promise.all(promises)
        .then(res => {
          this.apiLoading = false;
          this.apiLoaded = true;
          return res;
        })
        .catch(err => {
          this.apiError = err;
          this.apiLoading = false;
          return err;
        });
    },
  },
};
</script>
